/* @flow */

import React from 'react';
import Spinner from '@uniiverse/library/components/spinner';

import style from './index-module.css';

const LoadingEvents: Function = (): React$Element<*> => (
  <div className={style.loading}>
    <Spinner type="circle" size="large" />
  </div>
);

export default LoadingEvents;



// WEBPACK FOOTER //
// ./src/components/profile/loading-events/index.js